import React from 'react';
import { Flex, Box } from 'reflexbox';
import {
  Footer,
  Heading,
  Block,
  Text,
} from 'rebass';

import { Link } from 'react-router';

import SharedConfig from 'shared/config';

const RaidbotsFooter = () => (
  <Footer
    backgroundColor="black"
    pb={1}
  >
    <Flex justify="center" style={{ width: '100%' }}>
      <Box col={12} px={3} style={{ maxWidth: 1200, width: '100%' }}>
        <Flex justify="space-between" wrap>
          <Box>
            <Heading level={4}>
              Etc
            </Heading>
            <Block>
              <Text>
                <Link to="/developers" href="/developers">
                  Developers
                </Link>
              </Text>
              <br />
              <Text>
                <a
                  href="https://medium.com/raidbots"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Blog Archive
                </a>
              </Text>
              <br />
              <Text>
                <Link to="/tou" href="/tou">
                  Terms of Use
                </Link>
              </Text>
              <Text>
                <Link to="/privacy" href="/privacy">
                  Privacy Policy
                </Link>
              </Text>
            </Block>
          </Box>
          <Box>
            <Heading level={4}>
              Contact
            </Heading>
            <Block>
              <Text>
                <a href={SharedConfig.links.supportSite} target="_blank" rel="noopener noreferrer">
                  Support / Help
                </a>
              </Text>
              <br />
              <Text>
                <a href={SharedConfig.links.discord} target="_blank" rel="noopener noreferrer nofollow">
                  Raidbots Discord
                </a>
              </Text>
              <br />
              <Text>
                Made by Seriallos
              </Text>
            </Block>
          </Box>
        </Flex>
      </Box>
    </Flex>
  </Footer>
);

RaidbotsFooter.displayName = 'RaidbotsFooter';

export default RaidbotsFooter;
